<template>
  <router-link :to="{ name: 'breakdown', params: { mealbreakdown: mealURL }, query: {id: this.meal.ID} }" class="meal-item" v-if="this.meal.ID != null" @click.native="clearSearch">
      <img v-if="meal.Photo" :src="require(`../assets/meals/${meal.Photo}`)" alt="">
      <div v-else class="missing-photo"></div>
      <div class="meal-name">
        {{meal.Meal}}
      </div>
  </router-link>
</template>

<script>

export default {
  name: 'MealItem',
  props: ['meal'],
  data() {
    return {

    }
  },
  computed: {
    mealURL() {
      return this.meal.Meal.replace(/\s+/g, '-')
    }
  },
  methods: {
    clearSearch() { // Clear search item once someone views a meal
      this.$store.commit('Meals/UPDATE_FILTER_SEARCH_TERM', '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/styles/vars';
a {
  display: block;
}
.meal-item {
  display: flex;
  flex-flow: row;
  align-items: center;
  // margin-bottom: 3px;
  // margin-top: 3px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-family: $fPrimary;
  font-weight: $fwMed;
  font-size: 14px;
  color: $cBlack;
  text-decoration: none;
  background: $cWhite;
  transition: background 0.2s ease-out;
  @media (min-width: 768px) {
    font-size: 15px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  &:hover {
    background: #F4F8FA;
    transition: background 0.2s ease-out;
  }
  .missing-photo {
    width: 80px;
    height: 60px;
    margin-right: 25px;
    background: $cLightBG;
  }
  img {
    width: 80px;
    height: 60px;
    margin-right: 20px;
    @media (min-width: 768px) {
      margin-right: 25px;
    }
  }
}
</style>
